import React from 'react'
import { Link } from 'react-scroll';
import './Banner.css'

function Banner({headline, description, img, btnLabel}) {
  return (
    <div className="banner-section">
        <div className="container">
            <div className="banner-content">
                <div className="banner-header">
                    <h3 className="headline"> {headline} </h3>
                    <p>{description}</p>
                </div>
                <div className='banner-img-btn'>
                    <img src={img} alt="" className='banner-logo' />
                   <Link
                        activeClass="active" 
                        to="Contact" 
                        spy={true} 
                        smooth={true} 
                        duration={500}
                        >
                        <button className='btn btn-secondary'   
                        >{btnLabel}</button>
                    </Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Banner
